module.exports = __webpack_public_path__ + "static/media/lk.a3ff4ca1.png";